import {Fragment, h} from 'preact';
import Device from "./Device";
import {formatPrice} from "../../tools";
import ContractInfo from "./ContractInfo";

export default function SirenaContractRow({contract, account, amounts, onChangeCheckbox, isChecked, onChangeAmountInput, formParams, createOrderForContract, checkFineForContract, isFineChecked, messages}){
	const {meterDevices} = contract;
	let canEnterMeterReadings = false;
	let enterUrl = null;
	let workingDevices = false;
	let eventNoTechipu = 0;
	meterDevices.map(device => {
		if(device.canEnterMeterReadings) {
			canEnterMeterReadings |= true;
			enterUrl = device.enterUrl;
		} else {
			canEnterMeterReadings |= false;
		}
		if(device.stateStatus == 'working')
		{
			workingDevices = true;
		}
		eventNoTechipu += device.eventNoTechipu;
	});

	let enterMeterDisabledButtonText = 'Прибор учета неисправен или отсутствует*';
	if(!canEnterMeterReadings && workingDevices)
	{
		enterMeterDisabledButtonText = 'Показания были внесены сегодня';
	}

	const columnTitleClass = isChecked ? 'form-field__input-row form-field__input-row_ai_center':'';

	return (
		<Fragment>
			{!contract.isClosed && meterDevices.length > 0
			&& <ContractInfo
				canEnterMeterReadings={canEnterMeterReadings}
				enterUrl={enterUrl}
				contract={contract}
				account={account}
				formParams={formParams}
				amounts={amounts}
				createOrderForContract={createOrderForContract}
				onChangeAmountInput={onChangeAmountInput}
				enterMeterDisabledButtonText={enterMeterDisabledButtonText}
				checkFineForContract={checkFineForContract}
				isFineChecked={isFineChecked}
				eventNoTechipu={eventNoTechipu}
				messages={messages}
			/>}
			{!!contract.isClosed && (
				<div className="debt-table-item-2 debt-table__item">
					<div className="debt-table-item-2__row">
						<div className="debt-table-item-2__col"/>
						<div className="debt-table-item-2__col debt-table-item-2__col_fg_1">
							<div className="debt-table-item-2__text">
								Передача показаний невозможна, с {contract.closeDate} договор расторгнут
							</div>
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
}
